var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _Video_lockStatus, _Video_status, _Video_waitingId, _Video_handlers;
var VIDEO_PLAYBACK_DELAY_MS = 50;
var VIDEO_CLASS_NAME = 'prod-teaser__cover--video';
var VIDEO_SIZE = 180;
var Video = /** @class */ (function () {
    function Video(url, cover, posterUrl) {
        this.url = url;
        this.cover = cover;
        this.posterUrl = posterUrl;
        _Video_lockStatus.set(this, void 0);
        _Video_status.set(this, 'init');
        _Video_waitingId.set(this, void 0);
        _Video_handlers.set(this, {
            onerror: null,
            onload: null,
            onpause: null,
        });
        this.listeners = new Set();
    }
    Object.defineProperty(Video.prototype, "status", {
        get: function () {
            return __classPrivateFieldGet(this, _Video_status, "f");
        },
        set: function (status) {
            var e_1, _a;
            if (__classPrivateFieldGet(this, _Video_status, "f") === 'error' && status !== 'loading') {
                return;
            }
            if (status === 'waited' && __classPrivateFieldGet(this, _Video_status, "f") !== 'waiting') {
                return;
            }
            __classPrivateFieldSet(this, _Video_status, status, "f");
            try {
                for (var _b = __values(this.listeners), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var listener = _c.value;
                    listener(this);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Video.prototype, "loaded", {
        get: function () {
            return this.status !== 'loading' && this.status !== 'init' && this.status !== 'error';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Video.prototype, "locked", {
        get: function () {
            return __classPrivateFieldGet(this, _Video_status, "f") === 'locked';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Video.prototype, "playing", {
        get: function () {
            return this.video && this.video.currentTime && !this.video.paused && !this.video.ended;
        },
        enumerable: false,
        configurable: true
    });
    Video.prototype.show = function () {
        this.resetStatus();
    };
    Video.prototype.hide = function () {
        this.stop();
        this.resetStatus();
    };
    Video.prototype.preload = function () {
        if (this.status === 'loading' || this.loaded) {
            return;
        }
        this.remove();
        this.video = document.createElement('video');
        this.video.autoplay = true;
        this.video.muted = true;
        this.video.controls = false;
        this.video.playsInline = true;
        this.video.addEventListener('error', __classPrivateFieldGet(this, _Video_handlers, "f").onerror = this.onerror.bind(this));
        this.video.addEventListener('canplay', __classPrivateFieldGet(this, _Video_handlers, "f").onload = this.onload.bind(this));
        this.video.src = this.url;
        this.status = 'loading';
    };
    Video.prototype.wait = function () {
        var _this = this;
        if (this.status !== 'ready') {
            return;
        }
        clearTimeout(__classPrivateFieldGet(this, _Video_waitingId, "f"));
        __classPrivateFieldSet(this, _Video_waitingId, setTimeout(function () { return _this.status = 'waited'; }, VIDEO_PLAYBACK_DELAY_MS), "f");
        this.status = 'waiting';
    };
    Video.prototype.play = function () {
        if (this.status !== 'waited') {
            return false;
        }
        this.remove();
        this.video = document.createElement('video');
        this.video.width = VIDEO_SIZE;
        this.video.height = VIDEO_SIZE;
        this.video.autoplay = true;
        this.video.controls = false;
        this.video.poster = this.posterUrl;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.addEventListener('pause', __classPrivateFieldGet(this, _Video_handlers, "f").onpause = this.onpause.bind(this), { once: true });
        this.video.src = this.url;
        this.cover.append(this.video);
        this.cover.classList.add(VIDEO_CLASS_NAME);
        this.status = 'playing';
        return true;
    };
    Video.prototype.lock = function () {
        if (this.locked) {
            return;
        }
        this.stop();
        if (this.status === 'done') {
            __classPrivateFieldSet(this, _Video_lockStatus, 'done', "f");
        }
        else {
            __classPrivateFieldSet(this, _Video_lockStatus, this.loaded ? 'ready' : 'init', "f");
        }
        this.status = 'locked';
    };
    Video.prototype.unlock = function () {
        if (!this.locked) {
            return;
        }
        this.status = __classPrivateFieldGet(this, _Video_lockStatus, "f");
    };
    Video.prototype.destroy = function () {
        this.remove();
    };
    Video.prototype.addListener = function (listener) {
        this.listeners.add(listener);
    };
    Video.prototype.removeListener = function (listener) {
        this.listeners.delete(listener);
    };
    Video.prototype.stop = function () {
        if (!this.cover.classList.contains(VIDEO_CLASS_NAME)) {
            return;
        }
        this.cover.classList.remove(VIDEO_CLASS_NAME);
        this.remove();
    };
    Video.prototype.onerror = function () {
        this.status = 'error';
    };
    Video.prototype.onload = function () {
        this.status = 'ready';
    };
    Video.prototype.onpause = function () {
        this.status = 'done';
    };
    Video.prototype.resetStatus = function () {
        this.status = this.loaded ? 'ready' : 'init';
    };
    Video.prototype.remove = function () {
        if (!this.video) {
            return;
        }
        this.video.remove();
        this.video.removeEventListener('error', __classPrivateFieldGet(this, _Video_handlers, "f").onerror);
        this.video.removeEventListener('canplaythrough', __classPrivateFieldGet(this, _Video_handlers, "f").onload);
        this.video.removeEventListener('pause', __classPrivateFieldGet(this, _Video_handlers, "f").onpause);
        this.video = null;
    };
    return Video;
}());
_Video_lockStatus = new WeakMap(), _Video_status = new WeakMap(), _Video_waitingId = new WeakMap(), _Video_handlers = new WeakMap();
export default Video;
